import { Injectable } from '@angular/core';

type KEY = 'newsHidden' | 'pilThmBg' | 'pilThmCl' | 'pillow-agent-level' | 'pilThm';

@Injectable({
    providedIn: 'root',
})
export class StorageService {

    public setItem(item: KEY, value: string) {
        if (!item || !value || typeof value !== 'string') throw new Error('Wrong input for setStorage');
        localStorage.setItem(item, value);
    }

    public removeItem(item: KEY) {
        localStorage.removeItem(item);
    }

    public getItem(item: KEY) {
        return localStorage.getItem(item);
    }

    public clear() {
        ['newsHidden', 'pilThmBg', 'pilThmCl', 'pillow-agent-level'].forEach(key => {
            localStorage.removeItem(key);
        });
    }

}
